import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { FormHandles } from "models/propTypes/genericFormProps";
import { StyleEnums } from "models/enums";
//#endregion
//#region components
import {
  FormValidity,
  GridR,
  PageLayouts,
  ReloadEvent,
  StyledButton,
  ViewPanel,
  useFloatingMessages,
} from "components/common";
import { Grid } from "@mui/material";
import DocumentationLogList from "./list";
import DocumentationLogCreateFormContainer from "./createFormContainer";
import useAdvisorPermissions from "../usePermissions";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const DocumentationLogView: React.FC = () => {
  const { enqueueMessage } = useFloatingMessages();
  const { advisorViewsAvailable } = useAdvisorPermissions();

  const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);

  const formRef = React.useRef<FormHandles>(null);

  const onLogCreateClick = (onSubmitSuccess: () => void) => {
    if (formRef.current?.submit) {
      setIsSubmitting(true);
      formRef.current
        .submit()
        .then((res) => {
          enqueueMessage(
            LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Advisor.DocumentationLogCreated),
            StyleEnums.DisplayType.Success
          );
          onSubmitSuccess();
          formRef.current?.resetForm && formRef.current?.resetForm();
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    }
  };

  return (
    <ReloadEvent
      render={(reloadKey, reload) => (
        <PageLayouts.DashboardLayout
          entityKey={0}
          hasPermissions={advisorViewsAvailable}
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Advisor.DocumentationLog)}
          className={cssExports.documentationLogDetailView}
        >
          <Grid container rowGap={3} columnSpacing={3}>
            <GridR item md={8} xs={12}>
              <ViewPanel appearance="lg" gridSize="lg">
                <DocumentationLogList reloadKey={reloadKey} />
              </ViewPanel>
            </GridR>
            <GridR item md={4} xs={12}>
              <FormValidity
                render={(isValid, onValidityChange) => (
                  <ViewPanel
                    icon={IconDefinitionConstants.WCreate}
                    title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Advisor.AddToLog)}
                  >
                    <Grid container direction={"column"} spacing={3}>
                      <Grid item>
                        <DocumentationLogCreateFormContainer ref={formRef} onFormValidationChange={onValidityChange} />
                      </Grid>
                      <Grid item>
                        <StyledButton
                          size="sm"
                          displayType={StyleEnums.DisplayType.Info}
                          onClick={() => {
                            onLogCreateClick(reload);
                          }}
                          isSubmitting={isSubmitting}
                        >
                          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Save)}
                        </StyledButton>
                      </Grid>
                    </Grid>
                  </ViewPanel>
                )}
              />
            </GridR>
          </Grid>
        </PageLayouts.DashboardLayout>
      )}
    />
  );
};

export default DocumentationLogView;
